import {ModalComponent} from "../../../componets/common";
import {FC, useEffect} from "react";
import {ModalProps} from "../../../models";
import {getActiveSessions} from "../../../features/user/actions/getActiveSessions";
import {useAppDispatch, useAppSelector, useTranslate} from "../../../hooks";
import styles from "./SettingsActiveSessionsModal.module.scss"
import moment from "moment/moment";
import {ConfirmationDialog} from "../../../componets/ui/ConfirmationDialog";
import {removeActiveSession} from "../../../features/user/actions/removeActiveSession";
import {removeActiveSessions} from "../../../features/user/actions/removeActiveSessions";

export const SettingsActiveSessionsModal: FC<ModalProps>  = ({ isOpen, onClose }) => {
	const {
		activeSessions,
		currentSession,
		terminateAllSessions,
		terminateSession,
		sessionTermination,
		terminateSessionText,
		terminateAllSessionsText,
		sessionDateTimeMask,
		sessionTimeMask,
		today,
		at,
		lastActivity
	} = useTranslate([
		'activeSessions',
		'currentSession',
		'terminateAllSessions',
		'terminateSession',
		'sessionTermination',
		'terminateSessionText',
		'terminateAllSessionsText',
		'sessionDateTimeMask',
		'sessionTimeMask',
		'today',
		'at',
		'lastActivity'
	]);
	const dispatch = useAppDispatch();
	const { activeSessions: sessions = [], submitting} = useAppSelector((state) => state.user);
	const { data: token = {} } = useAppSelector((state) => state.authorization);
	const _removeActiveSession = (uuid: string) => {
		return dispatch(removeActiveSession(uuid)).finally(() => {
			dispatch(getActiveSessions());
		});
	};
	const _removeAllActiveSessions = () => {
		return dispatch(removeActiveSessions()).finally(() => {
			dispatch(getActiveSessions());
		});
	};
	useEffect(() => {
		dispatch(getActiveSessions());
	}, []);
	return (
		<ModalComponent isOpen={isOpen} onClose={onClose} title={activeSessions} width="640px">
			<div className={styles.list}>
				{[...sessions].sort((el) =>  {
					return el?.sessionUuid === token?.token_pair_id ? -1 : 1;
				}).map((el, i) => {
					const createdDt = moment(`${el.created}+00:00`);
					const lastActivityDt = moment(`${el?.lastActivity || el.created}+00:00`)
					return (
						<div key={i} className={styles.element}>
							<div className={styles.icon} data-type={el?.deviceType} />
							<div className={styles.content}>
								<div className={styles.title}>
									{el?.deviceType === "app" && <span>App</span>}
									{el?.os && <span>{el.os}</span>}
									{el?.browser && <span>{el.browser}</span>}
									{el?.deviceName && <span>{el.deviceName}</span>}
									{el?.sessionUuid === token?.token_pair_id && (
										<span className={styles.current}>
											<>{currentSession}</>
										</span>
									)}
								</div>
								<div className={styles.ip}>
									{createdDt.diff(moment().endOf("day"), "days") === 0 ? (
										<>
											{today.toLowerCase()} {createdDt.format(sessionTimeMask).replace("%c", at).replace("%p", 'val.')}
										</>
									) : (
										<>
											{createdDt.format(sessionDateTimeMask).replace("%c", at).replace("%p", 'val.')}
										</>
									)}
									{el?.city && <>, {el.city}</>}
									{el?.country && <>, {el.country}</>}
									{el?.ip && <>, {el.ip}</>}
								</div>
								<div className={styles.ip}>
									{lastActivity}&nbsp;
									{lastActivityDt.diff(moment().endOf("day"), "days") === 0 ? (
										<>
											{today.toLowerCase()} {lastActivityDt.format(sessionTimeMask).replace("%c", at).replace("%p", 'val.')}
										</>
									) : (
										<>
											{lastActivityDt.format(sessionDateTimeMask).replace("%c", at).replace("%p", '')}
										</>
									)}
								</div>
							</div>
							<div className={styles.actions}>
								{i > 0 ? (
									<ConfirmationDialog
										loading={submitting === 'pending'}
										title={sessionTermination}
										action={<a><>{terminateSession}</></a>}
										onSubmit={() => _removeActiveSession(el?.sessionUuid)}
									>
										<>{terminateSessionText}</>
									</ConfirmationDialog>
								) : (
									<ConfirmationDialog
										loading={submitting === 'pending'}
										title={sessionTermination}
										action={<a><>{terminateAllSessions}</></a>}
										onSubmit={() => _removeAllActiveSessions()}
									>
										<>{terminateAllSessionsText}</>
									</ConfirmationDialog>
								)}
							</div>
						</div>
					);
				})}
			</div>

		</ModalComponent>
	)
}
